import React from 'react';
import { toast } from 'react-toastify';
import Notification from '../components/Notification/Notification';

const AUTOCLOSE_DELAY_BY_TYPE = {
  success: 5000,
  error: 30000,
  info: 3000,
};

export const showNotification = (translationPath, type, id, Component = Notification) => {
  toast(<Component message={translationPath} notificationType={type} />, {
    toastId: id,
    type,
    autoClose: AUTOCLOSE_DELAY_BY_TYPE[type],
  });
};

export const clearNotification = (id) => {
  toast.dismiss(id);
};

export const clearAllNotifications = () => {
  toast.dismiss();
};
